import React, {useState} from 'react';
import ModalToBody from '../../../../base/ModalToBody';
import {Trans} from 'react-i18next';
import WristbandPreview from "./WristbandPreview";

const PreviewButton = ({wristband}) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <span>
            <button
                type="button"
                className="btn btn-outline-info m-btn btn-sm  m-btn--icon m--margin-left-5"
                onClick={() => setShowModal(true)}
            >
                <span>
                    <i className="la la-eye"/>
                    <span>
                        <Trans>Preview</Trans>
                    </span>
                </span>
            </button>

            <ModalToBody render={showModal}>
                <div
                    className="modal fade show"
                    id="m_modal_4"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    style={{
                        display: showModal ? 'block' : 'none',
                        zIndex: '1039'
                    }}
                >
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Preview
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => setShowModal(false)}
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{textAlign: 'center'}}>
                                <WristbandPreview wristband={wristband} />
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className={'modal-backdrop fade ' + (showModal ? ' show' : '')}
                    style={{
                        display: showModal ? 'block' : 'none',
                        zIndex: '1038'
                    }}
                    onClick={() => setShowModal(false)}
                />
            </ModalToBody>
        </span>
    );
};

export default PreviewButton;
